import React from 'react'

import clsx from 'clsx'

import { useMobileBottomNavigation } from '../useMobileBottomNavigation'
import { useMobileNavbar } from '../useMobileNavbar'

export const NavbarControlOverride = ({ children }) => {
  const { enabled: mobileBottomNavigationEnabled } = useMobileBottomNavigation()
  const { controls } = useMobileNavbar()

  return (
    <>
      {mobileBottomNavigationEnabled && controls && (
        <div className="flex sm:hidden items-center space-s-3 flex-shrink-0">
          {controls}
        </div>
      )}
      <div
        className={clsx(
          'items-center space-s-3 flex-shrink-0',
          mobileBottomNavigationEnabled && controls ? 'hidden sm:flex' : 'flex',
        )}
      >
        {children}
      </div>
    </>
  )
}
